<template>

  <div>

    <div 
      v-show="totalPage > 1"
      class="btn-group">

      <button
        class="btn btn-white btn-sm"
        v-on:click="onPageClick(1)"
        >
        <i class="fa fa-arrow-left"></i>
      </button>
      <button
        class="btn btn-sm"
        v-for="page in pageVisible()"
        v-bind:key="page"
        v-bind:class="page === currentPage ? 'btn-primary' : 'btn-white'"
        v-html="page"
        v-on:click="onPageClick(page)"
        >
      </button>
      <button
        class="btn btn-white btn-sm"
        v-on:click="onPageClick(totalPage)"
        >
        <i class="fa fa-arrow-right"></i>
      </button>

    </div>

    <span class="ml-2" v-html="pageCountText()"></span>

  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "AppPaging",
  components: {
  },
  data() {
    return {
      maxPageNumber: 10,
      totalPage: 0,
      totalCount: 0,
      currentPage: 1
    };
  },
  created() {
  },
  methods : {
    setTotalPage(totalPage, totalCount) {
      this.totalPage = totalPage;
      this.totalCount = totalCount;
    },
    setCurrentPage(currentPage) {
      this.currentPage = currentPage;
    },
    onPageClick(page) {
      this.currentPage = page;
      this.$emit('paging-data-change', this.currentPage);
    },
    
    pageVisible() {
      // 11 > 10
      if(this.totalPage > this.maxPageNumber) {
        if(this.currentPage <= (this.maxPageNumber / 2)) {
          // 1, 2, 3, 4, 5
          return Array.from({length:this.maxPageNumber}, (v, k) => k + 1)
        } else {
          if((this.totalPage - this.currentPage) < (this.maxPageNumber / 2)) {
            // (11 - x) < 5
            // 7, 8, 9, 10, 11
            return Array.from({length:this.maxPageNumber}, (v, k) => k + 1 + Math.floor(this.totalPage - this.maxPageNumber))
          } else {
            return Array.from({length:this.maxPageNumber}, (v, k) => k + 1 + Math.floor(this.currentPage - (this.maxPageNumber / 2)))
          }
        }
      } else {
        return this.totalPage;
      }
    },
    pageCountText() {
      if(this.totalCount === 0) {
        return '';
      }
      let start = ((this.currentPage - 1) * 100) + 1;
      let end = ((this.currentPage - 1) * 100) + 100;
      end = end < this.totalCount ? end : this.totalCount;
      return 'View ' + start + ' - ' + end + ' of ' + this.totalCount;
    },
    pageHtml(page) {
      return (page === this.currentPage) ? '*' + page + '*' : page
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/App/AppPaging.vue